import { DashboardElements } from '../dashboard/DashboardElements'
import { PanelBox } from '../default'

/**
 * Displays the main dashboard panel.
 *
 * @author Maria Eduarda Franke, Isadora Botassari
 * @returns {React.Component} The rendered DashboardPanel component.
 */
const DashboardPanel = () => {

    return (
        <PanelBox title='Análise de Score'>
            <DashboardElements />
        </PanelBox>
    )
}

export default DashboardPanel
